import { useCallback, type MutableRefObject } from "react";
import editModalFns from "../components/editModalFunctions";
import type { EditFormState } from "../components/EditModal";
import type { Firestore } from "firebase/firestore";

type Params = {
  db: Firestore;
  editId: string | null;
  editForm: EditFormState;
  editIsReadOnly: boolean;
  currentUserString: () => string | null;
  toMillis: (v: any) => number | null;
  LOCK_STALE_MS: number;
  splitSerialParts: (s: string) => any;
  normalizeSerialKey: (s: string) => string;
  buildDisplaySerial: (base: string, visit: number) => string;
  lastSerialAllocRef: MutableRefObject<{ changed: boolean; serialBaseKey: string; serialVisit: number; displaySerial: string; } | null>;
  refreshHomeList: () => Promise<void>;
  setIsEditOpen: (v: boolean) => void;
  setEditId: (v: string | null) => void;
  setEditForm: (updater: (prev: any) => any) => void;
};

export function useSaveEdit({
  db,
  editId,
  editForm,
  editIsReadOnly,
  currentUserString,
  toMillis,
  LOCK_STALE_MS,
  splitSerialParts,
  normalizeSerialKey,
  buildDisplaySerial,
  lastSerialAllocRef,
  refreshHomeList,
  setIsEditOpen,
  setEditId,
  setEditForm,
}: Params) {
  return useCallback(async (): Promise<void> => {
    if (!editId) return;

    await editModalFns.saveEdit({
      db,
      editId,
      editForm,
      editIsReadOnly,
      currentUserString,
      toMillis,
      LOCK_STALE_MS,
      splitSerialParts,
      normalizeSerialKey,
      buildDisplaySerial,
      serialAlreadyReallocated: !!(lastSerialAllocRef.current?.changed),
      refreshHomeList,
      setIsEditOpen,
      setEditId,
      setEditForm,
      alertFn: (m) => alert(m),
      consoleError: (e) => console.error(e),
    });
  }, [
    db,
    editId,
    editForm,
    editIsReadOnly,
    currentUserString,
    toMillis,
    LOCK_STALE_MS,
    splitSerialParts,
    normalizeSerialKey,
    buildDisplaySerial,
    lastSerialAllocRef,
    refreshHomeList,
    setIsEditOpen,
    setEditId,
    setEditForm,
  ]);
}
